<template>
  <div class="news">
    <banner :img="require('@/assets/img/bgtop.jpg')" title="云平台" :height="200" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="section-header">
          <h2>云平台服务</h2>
          <p>CLOUD PLATFORM SERVICES</p>
          <div class="section-border"></div>
        </div>

        <div class="content-nav">
          <div
            v-for="(item, index) in newsMap"
            :key="index"
            class="content-nav-btn"
            :class="{ 'content-nav-active': newstype === index }"
            @click="newstype = index"
          >
            <span>{{ item.Title }}</span>
          </div>
        </div>

        <div class="content-container">
          <div
            v-for="(item, index) in newsMap"
            :key="index"
            class="content-item"
            :class="{ 'content-item-active': newstype === index }"
          >
            <a :href="item.Links" target="_blank" rel="noopener noreferrer">
              <div class="item-img-wrapper">
                <img
                  :src="item.Img"
                  class="item-img"
                  :alt="item.Title"
                  @error="onImageError($event)"
                />
              </div>
              <h3 class="item-title">{{ item.Title }}</h3>
              <p class="item-content">{{ item.Content }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  name: "news",
  components: {
    Banner,
  },
  data() {
    return {
      loading: false,
      newstype: 0, // 默认选中第一个
      newsMap: [
        {
          Links: "http://1.95.12.208/login?redirect=%2Findex",
          Img: "https://ehuatech.com.cn/images/energy.png",
          Title: "储能云",
          Content: "提供实时监控、削峰填谷、数据分析和电价控制等功能，助力能源高效管理和智能化运维。",
        },
        {
          Links: "http://139.9.64.10/",
          Img: "https://ehuatech.com.cn/images/car.png",
          Title: "叉车云",
          Content: "叉车BMS云平台：实时监控电池状态，保障安全，延长寿命",
        },
        {
          Links: "http://106.53.164.220/ships/index.html",
          Img: "https://ehuatech.com.cn/images/bord.png",
          Title: "船舶云",
          Content: "船舶BMS云平台。",
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      // 模拟异步数据加载
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    onImageError(event) {
      event.target.src = 'https://via.placeholder.com/300x210?text=图片加载失败';
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;

  &-section {
    width: 100%;

    &-content {
      max-width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      padding: 20px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);

      .section-header {
        text-align: center;
        margin: 40px 0 30px;

        h2 {
          font-size: 36px;
          color: #1a75bb;
          margin: 0 0 10px;
          font-weight: 600;
        }

        p {
          font-size: 18px;
          color: #666;
          margin: 0 0 15px;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .section-border {
          border-bottom: 2px solid #1a75bb;
          width: 100px;
          margin: 0 auto;
        }
      }

      .content-nav {
        width: 600px;
        height: 60px;
        margin: 30px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #f8f9fa;
        border-radius: 30px;
        padding: 5px;
        box-shadow: 0 4px 10px rgba(0,0,0,0.1);

        &-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 50px;
          border-radius: 25px;
          background-color: transparent;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 18px;
          font-weight: 500;
          color: #666;

          &.content-nav-active {
            background-color: #1a75bb;
            color: #fff;
            box-shadow: 0 4px 8px rgba(26, 117, 187, 0.3);
          }

          &:hover {
            background-color: #e9ecef;
            color: #1a75bb;
          }
        }
      }

      .content-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
        gap: 50px;
        margin-top: 30px;
        padding: 20px 0;

        .content-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          border: 1px solid #e9ecef;
          border-radius: 12px;
          padding: 30px;
          margin: 0; /* 移除外边距 */
          transition: all 0.3s ease;
          background-color: #fff;
          box-shadow: 0 4px 8px rgba(0,0,0,0.05);

          a {
            text-decoration: none;
            color: inherit;
            width: 100%;
          }

          &:hover {
            border: 1px solid #1a75bb;
            box-shadow: 0 10px 25px rgba(26, 117, 187, 0.2);
            transform: translateY(-5px);
          }

          &.content-item-active {
            border: 2px solid #1a75bb;
            box-shadow: 0 10px 25px rgba(26, 117, 187, 0.3);
          }

          .item-img-wrapper {
            width: 100%;
            height: 200px;
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f8f9fa;
            border: 1px solid #e9ecef;
            position: relative;

            .item-img {
              max-width: 95%;
              max-height: 95%;
              object-fit: contain;
              transition: transform 0.3s ease;

              &:hover {
                transform: scale(1.05);
              }
            }
          }

          .item-title {
            font-size: 24px;
            color: #1a75bb;
            margin: 0 0 15px;
            font-weight: 600;
          }

          .item-content {
            font-size: 16px;
            color: #666;
            line-height: 1.6;
            margin: 0;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 992px) {
  .news-section-content {
    padding: 15px;
  }

  .content-nav {
    width: 90% !important;
  }

  .content-container {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important;
  }
}

@media (max-width: 768px) {
  .content-nav {
    height: auto !important;
    flex-direction: column;
    border-radius: 10px;

    &-btn {
      width: 100% !important;
      margin: 5px 0 !important;
      height: 45px !important;
    }
  }

  .content-container {
    grid-template-columns: 1fr !important;
    gap: 20px !important;
  }

  .section-header h2 {
    font-size: 30px !important;
  }
}

@media (max-width: 576px) {
  .news-section-content {
    padding: 10px;
  }

  .content-item {
    padding: 20px 15px !important;
  }

  .item-title {
    font-size: 20px !important;
  }

  .item-content {
    font-size: 14px !important;
  }
}
</style>